import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = {
  display: "flex",
  alignItems: "baseline",
}

export const avatar: SxStyleProp = {
  mr: [2],
  mb: 1,
  alignSelf: "start",
  position: "relative",
  top: "-2px",
}

export const name: SxStyleProp = {
  lineHeight: "heading",
  mb: "2px",
}

export const tooltip: SxStyleProp = {
  display: "flex",
  alignItems: "center",
}

export const roleName: SxStyleProp = {
  color: "primary",
}
